import React from "react";
import { Box, Flex, HStack, IconButton } from "@chakra-ui/react";
import { ChevronRightIcon, ChevronLeftIcon } from "@chakra-ui/icons";

/**
 * DotPaging
 * @param nPages {number} number of total pages
 * @param currentPage {number} current page number
 * @param paginate {function} function used to navigate pages
 * @returns {JSX.Element|string} dot style paging component
 * @constructor
 */
// eslint-disable-next-line react/prop-types
const DotPaging = ({ nPages, currentPage, paginate }) => {
  const canPrevPage = currentPage > 1;
  const canNextPage = currentPage < nPages;
  // disable paging in the event only a single page is required
  if (nPages <= 1) {
    return "";
  }
  return (
    <Flex alignItems={"center"} justifyContent={"center"} w={"full"}>
      <IconButton
        variant={"ghost"}
        color={"#fff"}
        isDisabled={!canPrevPage}
        _hover={{ background: "transparent" }}
        _focus={{ background: "transparent" }}
        _active={{ background: "transparent" }}
        _disabled={{ color: "rgba(0,0,0,.3)" }}
        aria-label={"Previous"}
        onClick={() => paginate(-1)}
        icon={<ChevronLeftIcon h={10} w={10} />}
        ml={4}
        data-testid={"previous-button"}
      />
      <HStack spacing={2} px={10}>
        {Array.from(Array(nPages).keys()).map((page, i) => {
          return (
            <Box
              key={i}
              h={2}
              mx={1}
              w={2}
              bg={
                currentPage === i + 1 ? "rgba(255,255,255,1)" : "rgba(0,0,0,.3)"
              }
              rounded={"full"}
            ></Box>
          );
        })}
      </HStack>
      <IconButton
        variant={"ghost"}
        color={"#fff"}
        isDisabled={!canNextPage}
        _hover={{ background: "transparent" }}
        _focus={{ background: "transparent" }}
        _disabled={{ color: "rgba(0,0,0,.3)" }}
        _active={{ background: "transparent" }}
        aria-label={"Next"}
        onClick={() => paginate(1)}
        icon={<ChevronRightIcon h={10} w={10} />}
        data-testid={"next-button"}
      />
    </Flex>
  );
};

export { DotPaging };
